export const initialProductLine = {
  description: "",
  quantity: "",
  rate: "",
};
export const initialInvoice = {
  logo: "../images/QAlogo_v2.png",
  logoWidth: 225,
  title: "INVOICE",
  invoiceId: "",
  remitPaymentTo: "Remit Payment to:",
  companyName: "Quality Claims Management Corp",
  attn: "Attn: Accounts Receivable",
  name: "",
  companyAddress: "2763 Camino del Rio S",
  companyAddress2: "San Diego, CA, 92108",
  companyCountry: "United States",
  billTo: "Bill To:",
  clientName: "",
  clientAddress: "",
  clientAddress2: "",
  clientCountry: "United States",
  invoiceTitleLabel: "Invoice #:",
  invoiceTitle: "",
  invoiceDateLabel: "Invoice Date:",
  invoiceDate: "",
  invoiceDueDateLabel: "Due Date:",
  invoiceDueDate: "",
  fileNoTitleLabel: "File #:",
  fileNoTitle: "",
  fileTypeTitleLabel: "File Type:",
  fileTypeTitle: "",
  referenceNoTitleLabel: "Reference #",
  referenceNoTitle: "",
  subjectTitleLabel: "Subject:",
  subjectTitle: "",
  serviceLineDescription: "Professional Services",
  serviceLineQuantity: "Qty",
  serviceLineQuantityRate: "Rate",
  serviceLineQuantityAmount: "Amount",
  serviceTotalLabel: "Services total",
  serviceLine: [],
  expenseLineDescription: "Expense Itemization",
  expenseLineQuantity: "Qty",
  expenseLineQuantityRate: "Rate",
  expenseLineQuantityAmount: "Amount",
  expenseTotalLabel: "Expense total",
  expenseLine: [],
  retainerCreditLabel: "Retainer Credit",
  retainerCredit: "",
  subTotalLabel: "Sub Total",
  taxLabel: "Sale Tax (10%)",
  totalLabel: "Total amount",
  total: "",
  currency: "$",
  notesLabel: "Notes",
  notes: "",
  termLabel: "Terms & Conditions",
  term: ".",
};
